// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1noKe","content":"Consent_content__1ZZYp","footer":"Consent_footer__3RMf9"};